export default __webpack_public_path__ + "static/media/reddit.b0cd4454.svg";